import React, { type ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Tones mirror the prototype's `.tag-soft` variants. `suggested` = brand tint,
 *  `edited` = neutral, `teal` = accent. */
type Tone = "suggested" | "edited" | "teal";

const TONES: Record<Tone, string> = {
  suggested: "vb-tag--suggested",
  edited: "vb-tag--edited",
  teal: "vb-tag--teal",
};

type Props = {
  children: ReactNode;
  tone?: Tone;
  className?: string;
};

/** Soft uppercase micro-tag (provenance: Suggested / Edited). Ported 1:1 from
 *  the prototype's `.tag-soft`. */
export function BadgeSoft({ children, tone = "suggested", className }: Props) {
  return <span className={cn("vb-tag", TONES[tone], className)}>{children}</span>;
}

export default BadgeSoft;
